import { LIGIN_API_URL } from "../constants";
import { axiosInstance } from "@src/shared/api";

interface RecoveryPasswordRequest {
  login: string;
  code?: string;
  new_password?: string;
}

export const recoveryPassword = (data: RecoveryPasswordRequest) =>
  axiosInstance.post<string>(LIGIN_API_URL.recoveryPassword(), data);
